(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.headerCoords = {};
    this.calcHeaderCoords()

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	calcHeaderCoords() {
    const clientRect = this.getBoundingClientRect();
    const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
    this.headerCoords.bottom = pageYOffset + clientRect.bottom;
    this.headerCoords.top = pageYOffset + clientRect.top;
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					this.header.classList.add('color-background-overlay-hidden', 'shopify-section-header-sticky');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					this.header.classList.remove('color-background-overlay-hidden', 'shopify-section-header-sticky');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerCoords.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
